import React from "react";
import { Card, Container, Button } from "react-bootstrap";
import PageLayout from "../Layouts/PageLayout";
import { ReactComponent as ProfileIcon } from "../Assets/Icons/profileIcon.svg";
import { ReactComponent as DeleteIcon } from "../Assets/Icons/deleteIcon.svg";
import { ReactComponent as PasswordIcon } from "../Assets/Icons/passwordIcon.svg";
import ProfileImg from "../Assets/Images/ProfileImg.png";
import { ToastContainer, toast } from "react-toastify";
import WarningIcon from "../Assets/Icons/warningIcon.svg";
import DustBinIcon from "../Assets/Icons/dustBinIcon.svg"

export default function AdminDeleteAccount() {
  const notify = () => toast.info("Account Deleted!");
  return (
    <Container fluid>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <PageLayout>
        <div>
          <h1 className="admin-profile-setting-heading">Settings</h1>
          <div className="profile-detail-parent">
            <Card
              style={{ width: "fit-content" }}
              className="profile-seetting-card"
            >
              <div className="admin-setting-list-con">
                <div className="admin-setting-list">
                  <ProfileIcon style={{ width: "1.5rem" }} fill="#A6A6A6" />
                  <p style={{ color: "#A6A6A6" }}>Profile</p>
                </div>
                <div className="admin-setting-list">
                  <PasswordIcon style={{ width: "1.5rem" }} fill="#A6A6A6" />
                  <p style={{ color: "#A6A6A6" }}>Password</p>
                </div>
                <div className="admin-setting-list">
                  <DeleteIcon style={{ width: "1.5rem" }} fill="Black" />
                  <p style={{ color: "black", fontWeight: "700" }}>
                    Delete Account
                  </p>
                </div>
              </div>
            </Card>
            <Card
              style={{ paddingRight: "5rem", paddingLeft: "5rem" }}
              className="profile-seetting-card"
            >
              <div>
                <div className="delete-account-sec-one">
                  <h2>Delete Account</h2>
                  <p>
                    Are you sure you want to delete your account?. Deleting your
                    account will wipe out everything in your account
                  </p>
                </div>
                <div className="delete-acc-card">
                  <div className="delete-acc-heading">
                    <img src={WarningIcon} />
                    <p>Warning</p>
                  </div>
                  <p className="delete-acc-warning-text">
                    By deleting your account, you will lose access to{" "}
                    <span style={{ fontWeight: "700" }}>Tranchepay</span>
                  </p>
                </div>
                <div className="delete-account-btn-con">
                    <Button onClick={notify} style={{display: 'flex', alignItems: 'center', fontSize: '0.85rem', gap: '0.50rem'}} variant="danger"><img src={DustBinIcon} />Delete Account</Button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </PageLayout>
    </Container>
  );
}
